export const getError = ({ error, text, heading }) => {
  return {
    heading: heading ?? "Sorry",
    text:
      error?.response?.data?.error?.message ??
      error?.response?.data?.message ??
      text,
  };
};
